var state = {
  workersFilter: [],
  vacancyFilter: '',
  workTypesFilter: [],
  outsourcingsFilter: [],
  isChangedFilter: false
};
var mutations = {
  setFilters: function setFilters(state, _ref) {
    var selectedWorkers = _ref.selectedWorkers,
        selectedType = _ref.selectedType,
        selectedWorkTypes = _ref.selectedWorkTypes,
        selectedOutsourcings = _ref.selectedOutsourcings;
    state.workersFilter = selectedWorkers;
    state.vacancyFilter = selectedType;
    state.workTypesFilter = selectedWorkTypes;
    state.outsourcingsFilter = selectedOutsourcings;
    state.isChangedFilter = true;
  },
  setIsChangedFilter: function setIsChangedFilter(state, value) {
    state.isChangedFilter = value;
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations
};